<template>
  <view class="popup-warp">
    <view class="popup" wx:class="{{popupClass}}">
      <view class="title">专属礼包已到账</view>
      <view wx:if="{{__mpx_mode__ === 'web'}}" class="coupon-list" scroll-y="{{true}}" bind:scroll="scroll">
        <view class="content">
          <view wx:for="{{couponList}}" wx:key="index" class="coupon">
            <view class="left">
              <coupon-price couponInfo="{{item.coupon}}" type="popup-result"/>
            </view>
            <view class="right">
              <view class="info">
                <view class="name">{{item.coupon.name}}</view>
                <view wx:if="{{item.coupon.usage_limit}}" class="usage-limit">{{item.coupon.usage_limit}}</view>
                <view wx:if="{{item.coupon.valid_period}}" class="valid-period">{{item.coupon.valid_period}}</view>
              </view>
            </view>
          </view>
        </view>
      </view>
      <scroll-view wx:else class="coupon-list" scroll-y="{{true}}" bind:scroll="scroll">
        <view class="content">
          <view wx:for="{{couponList}}" wx:key="index" class="coupon">
            <view class="left">
              <coupon-price couponInfo="{{item.coupon}}" type="popup-result"/>
            </view>
            <view class="right">
              <view class="info">
                <view class="name">{{item.coupon.name}}</view>
                <view wx:if="{{item.coupon.usage_limit}}" class="usage-limit">{{item.coupon.usage_limit}}</view>
                <view wx:if="{{item.coupon.valid_period}}" class="valid-period">{{item.coupon.valid_period}}</view>
              </view>
            </view>
          </view>
        </view>
      </scroll-view>
      <view class="footer">
        <image wx:if="{{ popupClass === 'is-more-3' }}" class="arrow-icon {{showMoreArrow ? 'is-visible' : ''}}" src="{{toWebpByFin('https://ut-static.udache.com/webx/ut/obhYNk1zIRZYShrz_riyh.png')}}" mode="widthFix" />
        <button class="btn" catchtap="click">{{btnText}}</button>
      </view>
      <view class="owner-tip">-  本活动由花小猪推送  -</view>
      <image bindtap="close" class="icon-close" src="{{toWebpByFin('https://ut-static.udache.com/webx/ut/OjikVXhZn2VJCZ7wpHInt.png')}}" mode="widthFix" />
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { trackEvent } from '@didi/webx-js'

createComponent({
  properties: {
    popupData: Object,
    pageConfig: Object,
  },
  attached() {
    trackEvent('userteam_fx_dialog_pg_sw', '领券弹窗展现')
  },
  data: {
    showMoreArrow: true,
  },
  computed: {
    btnText() {
      return this.pageConfig?.popup?.button?.text || '去使用'
    },
    couponList() {
      return this.popupData.rewards
    },
    showMore() {
      return this.couponList.length > 1
    },
    showMoreMask() {
      return this.couponList.length > 2
    },
    popupClass() {
      if (this.couponList.length > 2) {
        return 'is-more-3'
      } else {
        return `is-more-${this.couponList.length }`
      }
    },
  },
  methods: {
    close() {
      this.triggerEvent('close')
    },
    click() {
      this.triggerEvent('click')
    },
    scroll(e) {
      const offset = 10
      if (__mpx_mode__ === 'web') {
        this.showMoreArrow = e.srcElement.scrollTop + e.srcElement.getBoundingClientRect().height < e.srcElement.scrollHeight - offset
      } else {
        this.showMoreArrow = e.detail.scrollTop + this.height < e.detail.scrollHeight - offset
      }
    },
  },
})
</script>

<style lang="stylus" scoped>
.popup-warp
  z-index 99
  width 100%
  height 100%
  position fixed
  top: 0
  left 0
  background-color: rgba(0,0,0,.85)
  display: flex;
  justify-content: center;
  align-items center
  .owner-tip
    position: absolute;
    width: 100%;
    bottom: -60rpx;
    white-space: pre;
    font-size 18rpx
    color #fff
    text-align center
  .icon-close
    padding 16rpx
    width 40rpx
    position absolute
    left 50%
    bottom -140rpx
    transform translate(-50%)
  .popup
    position relative
    box-sizing border-box
    padding-top 168rpx
    top -5%
    width 626rpx
    height 672rpx
    background-image: url(https://ut-static.udache.com/webx/ut/RiBwgvdPYUIea1be1_QlY.png)
    background-size cover
    &.is-more-2
      height 872rpx
      background-image url(https://ut-static.udache.com/webx/ut/LBMUijfP-ngrD5uWv2S_9.png)
    &.is-more-3
      height 949rpx
      background-image url(https://ut-static.udache.com/webx/ut/6ZwyueCpT5PX5w9C4ptJZ.png)
      .coupon-list
        height 540rpx
        .content
          padding-bottom 90rpx
      .footer
        height 300rpx
        background-image url(https://ut-static.udache.com/webx/ut/IrjdTFbP4jY6O9VB6EqJM.png)
    .coupon-list
      height 380rpx
      padding 0 33rpx
      box-sizing: border-box;
      overflow-y auto
      margin 0 auto
      &::-webkit-scrollbar
        display: none;
      .coupon
        width 562rpx
        height 162rpx
        background-image: url('https://ut-static.udache.com/webx/ut/VI9M7XXgvUg2mENCvOOoP.png')
        background-size cover
        display flex
        padding 8rpx 20rpx 8rpx 16rpx
        box-sizing border-box
        & +.coupon
          margin-top 25rpx
        .left
          flex 1
          position relative
        .right
          width 300rpx
          box-sizing border-box
          display flex
          align-items: center;
          .info
            flex: 1;
            margin-left 44rpx
            .name
              font-size: 32rpx;
              font-family: PingFang SC;
              font-weight: 600;
              color: #B14536;
              text-shadow: 1px 1px 0px #FFFFFF;
              margin-bottom 18rpx
              line-height 1
            .usage-limit, .valid-period
              font-size: 17rpx;
              font-family: PingFang SC;
              font-weight: 400;
              color: #848484;
              line-height 1.3
    .icon-arrow
      z-index 4
      width 42rpx
      position: absolute;
      bottom: 267rpx;
      left 50%
      transform translateX(-50%)
    .footer-image
      z-index 2
      width: 610rpx
      position: absolute;
      bottom: 0;
    .title
      text-align center
      letter-spacing: 0;
      margin-bottom 25rpx
      font-size: 33rpx;
      font-family: PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      background: linear-gradient(179deg, #FFFEFB 0%, #FFF2B4 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    .footer
      background-image url(https://ut-static.udache.com/webx/ut/RhmY-NkyXsgEBId0mTxdu.png)
      background-size cover
      width 100%
      height 270rpx
      position absolute
      bottom 0
      left 0
      text-align center
      .arrow-icon
        width 33rpx
        margin-top 45rpx
        transition opacity 0.5s
        opacity 0
        &.is-visible
          opacity 1
    .btn
      z-index 9
      position absolute
      bottom 47rpx
      left 50%
      background-image: url(https://ut-static.udache.com/webx/ut/jETYAhdwBorgAcLqLc4rM.png)
      background-size: cover
      width 512rpx
      height 121rpx
      line-height 121rpx
      text-align center
      transform translate(-50%)
      font-family: PingFang SC;
      font-size: 51rpx;
      font-weight: bold;
      color: #E34F49;
      background-color: transparent;
      border none
      &::after
        border none
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {
    "coupon-price": "../common/coupon-price.mpx"
  }
}
</script>
